import { FILTER, Metric } from "@/constants";
import { SearchFilter } from "@/types/SearchFilter";
import { formatDateForApi } from "@/utils";
import { MENTION_VIEW_DATE_RANGES } from "@/views/MentionsView/MentionLayout/ranges";

export const MODAL_FILTER_PREFIX = "m_" as const;
export const MENTIONS_MODAL_OPEN_PARAM = "modal_open" as const;

// List the disallowed parameters that we don't want to be able to pass to the modal
type MentionModalDisallowedParams = typeof FILTER.TAG;

type MentionModalParameters = Omit<SearchFilter, MentionModalDisallowedParams>;

// Create a type that reflects all of the SearchFilter params(+ our own), but with a prefix to avoid collisions
type MentionModalPrefixedFilterParameters = PrefixKeys<
  typeof MODAL_FILTER_PREFIX,
  MentionModalParameters
> & {
  [MENTIONS_MODAL_OPEN_PARAM]?: Metric;
  searches: string;
  report: string;
};

// Merge and export the prefixed params with the modals own params
export type MentionModalUrlParameters =
  Partial<MentionModalPrefixedFilterParameters>;

export const DEFAULT_DATES = MENTION_VIEW_DATE_RANGES.find(
  (range) => range.default
);

export const DEFAULT_DATES_API_FRIENDLY = {
  [FILTER.START_DATE]:
    DEFAULT_DATES?.startDate && formatDateForApi(DEFAULT_DATES?.startDate),
  [FILTER.END_DATE]:
    DEFAULT_DATES?.endDate && formatDateForApi(DEFAULT_DATES?.endDate),
};
